import React from "react";

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-4">
      <div className="container mx-auto text-center">
        <p>&copy; 2023 Your Website Name</p>
      </div>
    </footer>
  );
}

export default Footer;
